var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19715 17.1971C3.67919 16.4318 4.61365 15.3111 4.66862 14.0849C4.72782 13.2181 4.04702 10.4401 5.69185 8.14413C9.99211 2.07641 23.7936 3.98759 23.9585 12.9644C24.0135 17.1674 21.4679 18.5205 20.7322 21.0448C20.3643 22.3683 20.4447 23.8736 21.1001 24.8927C21.1593 24.9984 21.7216 26.1442 17.9838 28.3133C14.7025 30.1992 13.2014 30.656 12.3473 30.3769C11.9498 30.2543 11.9499 29.9667 11.9499 29.9667C11.8357 28.3895 11.7553 22.8292 9.48469 23.2647C6.62208 23.8482 4.10622 24.0809 4.95612 20.7151C4.27112 20.7151 3.99208 20.1315 4.55868 19.8017C3.99208 19.8017 3.87792 19.2858 4.25001 18.956C4.24579 18.4444 2.06395 18.9815 3.19715 17.1971Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5774 0.00433573C20.1947 0.376433 24.0552 3.30251 25.2984 7.23489C25.4252 7.70424 25.5394 8.47364 25.6113 9.07407C25.6663 9.53496 25.2688 9.94101 24.7444 9.94101C3.36579 9.94101 3.36577 9.94101 3.36577 9.94101C-1.25161 9.94101 1.4884 9.94101 1.4884 9.94101C0.659634 9.94101 0 9.36177 0 8.60912C0 7.80995 0.659634 7.23056 1.4884 7.23056C6.52016 7.23056 3.78014 7.23056 3.78014 7.23056C5.02328 3.29817 8.82036 0.372097 13.5012 0H15.5774V0.00433573Z",
    fill: "#80ACD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkersIcon);
export default __webpack_public_path__ + "static/media/workersIcon.c2347870a65ac3a11521176d34adcb7f.svg";
export { ForwardRef as ReactComponent };